// API configuration for different environments
// In production, REACT_APP_API_URL will be set via Netlify environment variables
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export default API_URL;
